import { Box } from '@material-ui/core'
import React, { useState } from 'react'
import EditDetailsDialog from './EditDetailsDialog'
import { StatusLineComponent } from '../../../common/StatusLine'
import CallMerge from '@material-ui/icons/CallMerge'
import { StatusLine } from '../../../../types'
import { ButtonComponent } from '../../../common/Button'

export function MergeControl(props: { onMergeChange: Function; onCreateMerge: Function; mergeStatus: StatusLine }) {
  const { onMergeChange: onChangeMerge, onCreateMerge, mergeStatus } = props
  const [openDialog, setOpenDialog] = useState(false)

  function applyCallback(title: string, message: string) {
    onChangeMerge(title, message)
    setOpenDialog(false)
  }

  return (
    <React.Fragment>
      <Box className='upperBox'>
        <EditDetailsDialog
          apply={applyCallback}
          visible={openDialog}
          close={() => {
            setOpenDialog(false)
          }}
        />
        <Box className='statusLine'>
          <StatusLineComponent status={mergeStatus} />
        </Box>
        <Box className='flexCenter'>
          <ButtonComponent
            callback={() => {
              setOpenDialog(true)
            }}
            text='Edit Details'
            classNames='margin-right'
          />
          <ButtonComponent callback={onCreateMerge} text={'Merge'} icon={<CallMerge />} />
        </Box>
      </Box>
    </React.Fragment>
  )
}
